import { NumberInput as NumberInputMantine } from "@mantine/core";
import styled from "styled-components";

export const NumberInput = styled(NumberInputMantine)`
  .mantine-Input-input {
    border: none !important;
    color: ${({ theme }) => theme.cor9}!important;
    background-color: ${({ theme }) => theme.cor27}!important;
    height: 38px;
    font-size: 16px;

    ::placeholder {
      color: ${({ theme }) => theme.cor70}!important;
    }
  }

  .mantine-InputWrapper-label {
    color: ${({ theme }) => theme.cor9} !important;
    font-size: 16px !important;
    background-color: transparent !important;
  }
`;
